import { ShortUnitId, numberFormatUnits } from "../constants";
/**
 *
 * @param value
 * @param unit
 * @param precision
 * @param fixedPrecision 默认为 true
 * @returns
 */
export var humanizeNumberValue = function (value, unit, precision, fixedPrecision) {
    var baseNumberUnitIndex = 0;
    var sign = Math.sign(value);
    var positiveValue = Math.abs(value);
    if (unit) {
        var numberUnitIndex = numberFormatUnits.findIndex(function (numberUnit) {
            return numberUnit.id.toLocaleLowerCase() === unit.toLocaleLowerCase();
        });
        if (numberUnitIndex !== -1) {
            baseNumberUnitIndex = numberUnitIndex;
        }
    }
    var numberFormatUnit = numberFormatUnits[baseNumberUnitIndex];
    for (var i = baseNumberUnitIndex + 1; i < numberFormatUnits.length; ++i) {
        if (positiveValue /
            (numberFormatUnits[i].divisor /
                numberFormatUnits[baseNumberUnitIndex].divisor) >=
            1) {
            numberFormatUnit = numberFormatUnits[i];
        }
        else {
            break;
        }
    }
    if (numberFormatUnit.id === ShortUnitId.None) {
        return convertFixedPrecision((sign * positiveValue).toFixed(precision !== null && precision !== void 0 ? precision : 2), fixedPrecision);
    }
    else {
        return (convertFixedPrecision(((positiveValue /
            (numberFormatUnit.divisor /
                numberFormatUnits[baseNumberUnitIndex].divisor)) *
            sign).toFixed(precision !== null && precision !== void 0 ? precision : 2), fixedPrecision) + numberFormatUnit.display);
    }
};
/**
 *
 * @param value
 * @param fixedPrecision 默认为 true
 * @returns
 */
export function convertFixedPrecision(value, fixedPrecision) {
    if (fixedPrecision === false) {
        return (+value).toString();
    }
    return value;
}
//# sourceMappingURL=number.js.map